export default __webpack_public_path__ + "static/media/icon_record_video.0b7a8f4e.svg";